import React, { forwardRef, useState } from 'react';
import styled from 'styled-components';

import Button from '@ui/atoms/Button';

import TextInput, { IStyledTextInputProps } from '@ui/forms/TextInput';

import SearchIcon from '@assets/vectors/icon-search.inline.svg';
import ClearIcon from '@assets/vectors/search-clear.inline.svg';

import theme from '@theme/FolxTheme';

export interface ISearchInputProps extends IStyledTextInputProps {
	clear: () => void;
}

const SearchText = styled(TextInput)`
	padding: 0 ${theme.spacing.sm};

	input {
		padding: ${theme.spacing.sm} 0;
	}

	svg {
		height: ${theme.spacing.md};
		width: ${theme.spacing.md};
		flex-shrink: 0;
	}

	path {
		fill: ${theme.colors.black};
	}

	circle {
		stroke: ${theme.colors.black};
	}

	${Button} {
		background: none;
		border: none;
		width: auto;
	}
`;

const SearchInput = forwardRef<HTMLInputElement, ISearchInputProps>(
	(
		{
			borderRadius = 'md',
			placeholder = 'Search',
			labelVariant = 'body',
			clear = () => {
				return;
			},
			...restProps
		},
		ref
	) => {
		return (
			<SearchText
				borderRadius={borderRadius}
				startDecorator={<SearchIcon />}
				placeholder={placeholder}
				labelVariant={labelVariant}
				ref={ref}
				{...restProps}>
				<Button
					ariaLabel="Clear Search Text"
					label={<ClearIcon alt="Clear Icon" />}
					onClick={() => {
						clear();
					}}
				/>
			</SearchText>
		);
	}
);
SearchInput.displayName = 'SearchInput';

export default styled(SearchInput)``;
